module.exports = __webpack_public_path__ + "static/media/kgrowth2.dc421170.png";